import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React from 'react';
import { Button } from '../../flayr-components/Button/Button';

interface ICloseBtnProps {
  onClick?: (e?: any) => void;
  shadow?: any;
  size?: 'sm' | 'md' | 'lg';
  clear?: boolean;
}

const CloseBtn: React.FC<React.PropsWithChildren<ICloseBtnProps>> = ({
  onClick,
  shadow,
  size = 'md',
  clear,
}) => {
  return (
    <Button
      onClick={onClick}
      shadow={shadow}
      round
      className={classnames('pl-0 pr-0 pt-0 pb-0', {
        'w-6 h-6': size === 'sm',
        'w-8 h-8': size === 'md',
        'w-10 h-10': size === 'lg',
      })}
      clear={clear}
    >
      <FontAwesomeIcon icon={faTimes} />
    </Button>
  );
};
export default CloseBtn;
